import {needsDriverNotification} from './allocation'
import {allocationStatusForRow} from './attention-lens'
import type {CommitmentJobDisplay} from './commitment-job-display'
import {buildCommitmentJobDisplay} from './commitment-job-display'
import type {TimelineJobRow} from './job-rows'
import {deriveOperationalState, type OperationalState} from './operational-state'

export type BoardLane = 'needs_action' | 'notify_drivers' | 'dispatched'

export type BoardLaneJob = {
    job: TimelineJobRow
    display: CommitmentJobDisplay
    operational: OperationalState
    lane: BoardLane
}

export type BoardLaneSections = {
    needs_action: BoardLaneJob[]
    notify_drivers: BoardLaneJob[]
    dispatched: BoardLaneJob[]
}

export function classifyBoardLane(job: TimelineJobRow, _operational?: OperationalState): BoardLane {
    void _operational
    if (allocationStatusForRow(job) !== 'ready' || (job.unconfirmedRentalCount ?? 0) > 0) {
        return 'needs_action'
    }

    return job.allocations.some(needsDriverNotification) ? 'notify_drivers' : 'dispatched'
}

export function buildBoardLaneSections(jobs: TimelineJobRow[]): BoardLaneSections {
    const sections: BoardLaneSections = {
        needs_action: [],
        notify_drivers: [],
        dispatched: [],
    }

    for (const job of jobs) {
        const allocationStatus = allocationStatusForRow(job)
        const display = buildCommitmentJobDisplay(job)
        const operational = deriveOperationalState(job, allocationStatus)
        const lane = classifyBoardLane(job, operational)

        sections[lane].push({job, display, operational, lane})
    }

    return sections
}
